<template>
<modal v-if="display" btn="Save" @submit="save" 
  :title="!coachAssessment.id ? 'Create An Assessment' : 'Assessment'"
  @close="$emit('close')">
      <v-checkbox v-model="coachAssessment.notify_on_completion" label="Notify me when someone completes an assessment" />
      <v-checkbox v-model="coachAssessment.cta_enabled" label="Display a Call To Action (For New Users)" />
      <div v-if="coachAssessment.cta_enabled">
        <div class="section">
          <h4>Your Call to Action</h4>
          <div class="help-text">Your CTA will only be displayed for new users</div>
          <cta :cta="coachAssessment" class="small-bottom" />
        </div>
        <h-input label="When CTA is clicked where should the user be directed to?" v-model="coachAssessment.cta_link" hint="Full URL for CTA"/>
        <h-input label="URL Text" v-model="coachAssessment.cta_link_text"/>
        <h-input label="Header for your CTA" v-model="coachAssessment.cta_title"/>
        <h-input label="Subtitle for your CTA" v-model="coachAssessment.cta_subtitle"/>
      </div>
      <v-alert type="error" :value="error">{{error}}</v-alert>
</modal>
</template>

<script>
import modal from "@/components/modal/default";
import cta from "@/components/assessmentResults/cta";
import snackBar from "@/services/hubs/snackbar";
import dataStore from "@/services/api/store";

export default {
  components: { modal, cta },
  props: [ "coachAssessment", "display" ],
  data() {
    return {
      assessments: [],
      error: ""
    };
  },
  created() {

  },
  methods: {
    save() {
      if (this.coachAssessment.cta_enabled && (this.coachAssessment.cta_link == "https://example.com" || !this.coachAssessment.cta_link)) {
        this.error = "Your CTA needs a real link to forward users to";
        return;
      }

      let promise;
      if (this.coachAssessment.id) {
        promise = this.coachAssessment.save();
      } else {
        promise = dataStore.create("CoachCreatedAssessments", this.coachAssessment);
      }
      promise.then((r) => {
        this.$emit("refresh", r);
        snackBar.update("Saved");
      });
      this.close();
    },
    close() {
      this.error = "";
      this.$emit("close");
    }
  }
};
</script>
